export interface PrimaryCardHeaderProps {
  label: string;
  children?: React.ReactNode;
}

export const PrimaryCardHeader: React.FC<PrimaryCardHeaderProps> = (props) => {
  return (
    <div className="ucl-card-header ucl-card__header">
      <h4 className="bp5-heading">{props.label}</h4>
      {props.children}
    </div>
  );
};

export default PrimaryCardHeader;
